var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "cog-spinner cog-input",
      class: { "is-read-only": _vm.readonly }
    },
    [
      _vm.readonly
        ? [_vm._v(_vm._s(_vm.internalValue || " "))]
        : _c("c-input-number", {
            style: `max-width: ${_vm.maxWidth};`,
            attrs: {
              id: _vm.id ? "cog-" + _vm.id : null,
              type: "text",
              placeholder: _vm.placeholder,
              min: _vm.actualMin,
              max: _vm.actualMax,
              sensitivity: 333,
              step: _vm.step,
              format: _vm.format,
              precision: _vm.precision
            },
            on: {
              change: _vm.handleChange,
              focus: _vm.handleFocus,
              blur: _vm.handleBlur
            },
            model: {
              value: _vm.internalValue,
              callback: function($$v) {
                _vm.internalValue = $$v
              },
              expression: "internalValue"
            }
          })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }